import { render, staticRenderFns } from "./DepositReminder.vue?vue&type=template&id=d6b9e32c"
import script from "./DepositReminder.vue?vue&type=script&lang=js"
export * from "./DepositReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports